import React from 'react'
import { Link } from 'react-router-dom'
import { getTopTerritories, getTerritoryStatusColor, formatLastActivity } from '../TerritoryGrid/territoryUtils'
import './homePanel.css'
import './HomeFeaturedTerritories.css'

const RANK_LABELS = ['I', 'II', 'III']

const STATUS_ICONS = {
  Guerra: '⚔',
  Paz: '●',
  Tensión: '⚡',
  'Conflicto Interno': '⚡',
  Alianza: '◎',
  Neutral: '◈',
}

export default function HomeFeaturedTerritories({ territories = [] }) {
  const top = getTopTerritories(territories, 3)

  return (
    <section
      className="home-bento-card home-bento-card--territories home-featured-territories"
      aria-label="Territorios en conflicto"
    >
      <header className="home-panel__header">
        <span className="home-panel__eyebrow">陣 · Frente de batalla</span>
        <h2 className="home-panel__title">Territorios en conflicto</h2>
        <p className="home-panel__subtitle">
          Los frentes más activos, donde la guerra perdura reclamando sangre y gloria
        </p>
      </header>

      {top.length === 0 ? (
        <p className="home-panel__empty">Aún no hay territorios con actividad registrada.</p>
      ) : (
        <div className="home-featured-territories__grid">
          {top.map((territory, index) => {
            const statusColor = getTerritoryStatusColor(territory.territory_status)
            const statusIcon = STATUS_ICONS[territory.territory_status] || '◈'
            const rankLabel = RANK_LABELS[index] || String(index + 1)
            const isTop = index === 0
            const leaderName = territory.emperor_name || territory.leader_name
            const leaderTitle = territory.leader_title || (territory.emperor_name ? 'Emperador' : 'Kage')
            const combats = Number(territory.combatCount || 0)
            const characters = Number(territory.characterCount || 0)
            const activityLabel = territory.lastActivity
              ? formatLastActivity(territory.lastActivity)
              : null

            return (
              <Link
                key={territory.slug || territory.territoryId || index}
                to={`/han/${territory.slug}`}
                className={`home-territory-card${isTop ? ' home-territory-card--top' : ''}`}
              >
                <aside className="home-territory-card__seal" aria-hidden="true">
                  <span className="home-territory-card__rank">{rankLabel}</span>
                </aside>

                <div className="home-territory-card__main">
                  {(territory.territory_status || activityLabel) && (
                    <header className="home-territory-card__kicker">
                      {territory.territory_status && (
                        <span
                          className="home-territory-card__status"
                          style={{ color: statusColor }}
                        >
                          <span aria-hidden="true">{statusIcon}</span>
                          {territory.territory_status}
                        </span>
                      )}
                      {activityLabel && (
                        <span className="home-territory-card__time">{activityLabel}</span>
                      )}
                    </header>
                  )}

                  <h3 className="home-territory-card__name">{territory.name}</h3>

                  {leaderName && (
                    <p className="home-territory-card__leader">
                      <span className="home-territory-card__leader-title">{leaderTitle}</span>
                      {leaderName}
                    </p>
                  )}

                  <dl className="home-territory-card__stats">
                    <div className="home-territory-card__metric">
                      <dd className="home-territory-card__metric-value">{combats}</dd>
                      <dt className="home-territory-card__metric-label">Combates</dt>
                    </div>
                    <div className="home-territory-card__metric">
                      <dd className="home-territory-card__metric-value">{characters}</dd>
                      <dt className="home-territory-card__metric-label">Shinobis</dt>
                    </div>
                  </dl>

                  <span className="home-territory-card__cta">
                    Ir al frente
                    <span className="home-territory-card__cta-arrow" aria-hidden="true">
                      →
                    </span>
                  </span>
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </section>
  )
}
